import axios from 'axios';
import { API_BASE_URL } from '@/config';

export async function getAudiences() {
  return (await axios.get(`${API_BASE_URL}/audiences`)).data;
}

export async function getAudience(id) {
  return (await axios.get(`${API_BASE_URL}/audiences/${id}`)).data;
}

export async function createAudience(formData) {
  return await axios.post(`${API_BASE_URL}/audiences`, formData);
}

export async function updateAudience(id, formData) {
  return await axios.put(`${API_BASE_URL}/audiences/${id}`, formData);
}

export async function updateAudienceTemplates(id, templates) {
  return await axios.put(
    `${API_BASE_URL}/audiences/${id}/templates`,
    templates,
  );
}

export async function toggleAudienceDisabled(id) {
  return await axios.patch(`${API_BASE_URL}/audiences/${id}/toggle-disabled`);
}
